<template src="./VerCuestionarioSeguimiento.html"></template>

<script>
import { consultarMarcacionesEncuentro } from "../../../apiService/request/CrudEncuentro";
import redes from "../../../js/redes";
import { serverBus } from "../../../main";
import {
  actualizarCuestionario,
  crearCuestionario
} from "../../../apiService/request/CrudSeguimiento";
import VerTarjetasNuevasMomento from "../../VerTarjetasNuevasMomento/VerTarjetasNuevasMomento";
import metodos_comunes from "../../../js/metodos_comunes";
export default {
  data() {
    return {
      posicionFormulario: -1,
      mostrarFormularioCompleto: false,
      mostrarRespuestaFormulario: false,
      formularioSeleccionado: "",
      flechaArriba: false,
      jsonValorSeleccionado: [],
      resultado: "",
      colorRojo: false,
      colorAmarillo: false,
      valorResultado: Number,
      arrayVariablesActualizar: [],
      banderaOcultarFlecha: false,
      panel: "",
      arrayFormulariosLlenados: []
    };
  },
  components: {
    VerTarjetasNuevasMomento
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
    prioridadComponente: {
      type: Number,
      default: 1
    },
    listaCuestionarios: Array,
    index: Number,
    preguntasEncuestas: Array,
    keyFormulario: String,
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  beforeDestroy() {},
  computed: {
    getVariablesFormularios() {
      return this.$store.getters.getVariablesFormulariosOverlay;
    },
    getBanderaFormularioExistenteAbierto() {
      return this.$store.getters.getBanderaFormularioExistenteAbiertoOverlay;
    },
    valorSeleccionado() {
     if (this.getVariablesFormularios) {
       return this.getVariablesFormularios.map(dato => dato.valor)
     } 
     return []
    },
    opcionesSeleccionadas () {
      return this.valorSeleccionado.map((valor, index) => {
        return {
          nombre: `variable${index + 1}`,
          valor: valor
          }
      });
    },
    opcionesMapeadas () {
      return this.opcionesSeleccionadas.map(opcion => {
            if (opcion.valor === "Sí") {
              return 1;
            } else if (opcion.valor === "No"){
              return 0;
            }
          });
    },
    valorMensajeResultado() {
      const resultado_red = redes.logica_marcaciones(this.opcionesMapeadas);
      return resultado_red.indexOf(Math.max(...resultado_red));
    },
    mensajeResultado() {
      switch(this.valorMensajeResultado) {
        case 0:
          return "Adjuntar en observación el motivo de la llamada";
        case 1:
          return "Asignar cita prioritaria";
        case 2:
          return "Indicar cómo realizar el ciclo de rescate";
        case 3:
          return "Remitir a urgencias";
        default:
          return null;
      }
    },
  },
  beforeUpdate: function() {
    if (this.preguntasEncuestas.length == 0) {
      this.arrayVariablesActualizar = [];
      this.flechaArriba = true;
      this.jsonValorSeleccionado = [];
      this.mostrarRespuestaFormulario = false;
    }
  },
  methods: {
    reiniciarPanelExpansible() {
      this.panel = null;
      this.formularioSeleccionado = "";
    },
    consultarFormulario() {
      serverBus.$emit("consultarCuestionarioExistenteOverlay", true);
    },
    // cambia la vista del formulario
    mostrarFormulario(nombreformulario, index) {
      console.log(nombreformulario)
      console.log('panel', this.panel)

      if (this.panel !== null && this.panel >= 0) {
        this.formularioSeleccionado = "";
        if (this.posicionFormulario === index) {
          return;
        }
      }
      this.posicionFormulario = index;
      if (this.deshabilitado) {
        this.$store.dispatch("setVariablesFormulariosOverlay", []);
        this.$store.dispatch(
          "setIdFormularioOverlay",
          this.listaCuestionarios[index].completado
        );
        serverBus.$emit(
          "consultarCuestionarioExistenteOverlay",
          this.listaCuestionarios[index].completado,
          this.listaCuestionarios[index].tipo,
          this.listaCuestionarios[index].nombre
        );
        this.formularioSeleccionado = nombreformulario;
        this.flechaArriba = true;
        this.jsonValorSeleccionado = [];
        this.mostrarRespuestaFormulario = false;
      }
    },
    SeleccionValor(index) {
      if (this.keyFormulario == "seguimiento_epoc_triage") {
        this.jsonValorSeleccionado.splice(4, 1);
      }
      const jsonSeleccion = {
        nombre: "variable" + (index + 1),
        valor: this.valorSeleccionado[index]
      };
      const result = this.jsonValorSeleccionado.filter(
        elemento => elemento.nombre == "variable" + (index + 1)
      )[0];
      if (result) {
        result.valor = this.valorSeleccionado[index];
      } else {
        this.jsonValorSeleccionado.push(jsonSeleccion);
      }
      // this.$store.dispatch(
      //   "setVariablesActualizadasOverlay",
      //   this.jsonValorSeleccionado
      // );
    },
  }
};
</script>
<style lang="scss" scoped src="./VerCuestionarioSeguimiento.scss"></style>



// WEBPACK FOOTER //
// src/components/Seguimiento/VerCuestionarioSeguimiento/VerCuestionarioSeguimiento.vue